import AgentAvatar from '../common/AgentAvatar';
import styles from './TypingIndicator.module.css';

// Shown in the gap between the user pressing Enter and the first token of a
// conversational reply. It replaces the literal word "Thinking…" that used to
// sit there: three dots next to a face read as someone about to speak; a word
// next to a spinner read as a process running.
//
// The dots animate under the app's motion settings; global.css disables
// animations under prefers-reduced-motion, so they simply sit still there.
export default function TypingIndicator({ agent = 'hunter' }) {
  return (
    <div className={styles.wrap} role="status" aria-live="polite" aria-label="RepBuddy is typing">
      <AgentAvatar agent={agent} size={22} className={styles.avatar} />
      <span className={styles.dots} aria-hidden="true">
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </span>
    </div>
  );
}
